import React from 'react';
import CustomButton from './CustomButton';

export default class Navigation extends React.Component {
  /*constructor(props)
  {
    super(props);
  }*/

  toggleFullScreen() {
      var elem = document.documentElement;
      if (!document.fullscreenElement && !document.msFullscreenElement && !document.mozFullscreenElement && !document.webkitFullscreenElement) {
          if (elem.requestFullscreen) {
              elem.requestFullscreen();
          } else if (elem.msRequestFullscreen) {
              elem.msRequestFullscreen();
          } else if (elem.mozRequestFullScreen) {
              elem.mozRequestFullScreen();
          } else if (elem.webkitRequestFullscreen) {
              elem.webkitRequestFullscreen();
          }
      } else {
          if (document.exitFullscreen) {
              document.exitFullscreen();
          } else if (document.msExitFullscreen) {
              document.msExitFullscreen();
          } else if (document.mozExitFullScreen) {
              document.mozExitFullScreen();
          } else if (document.webkitExitFullscreen) {
              document.webkitExitFullscreen();
          }
      }
  }

  render() {
    return (
      <header>
        <CustomButton icon="home" x="10" y="10" nav url="/" tooltip="Home"/>
        <CustomButton icon="extension" x="10" y="85" nav url="/plugins" tooltip="Plugins"/>
        <CustomButton icon="color_lens" x="10" y="160" nav url="/ifs_editor" tooltip="IFS Editor"/>
        <CustomButton icon="compare" x="10" y="235" nav url="/glFraksl" tooltip="GlFraksl"/>
        <CustomButton icon="bookmark" x="10" y="310" nav url="/bookmarkemoji" tooltip="Emoji generator"/>
        <CustomButton icon="fullscreen" x="10" y="385" action={this.toggleFullScreen} tooltip="Toggle Fullscreen"/>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Component/Navigation.js